import React, { Fragment } from "react";

import {
  AssignDeviceDropdownItem,
  AssignDeviceModalItem,
} from "../../../../../../components/devices/assignDeviceItem";
import {
  BlockDeviceDropdownItem,
  BlockDeviceModalItem,
} from "../../../../../../components/devices/blockDeviceItem";
import { DeviceDropdownMenu } from "../../../../../../components/devices/DeviceDropdownMenu";
import { DeviceActionsToggle } from "../../../../../../components/devices/DeviceActionsDialog";
import { Mobile, NotMobile } from "../../../../../../hocs/Responsive";

export const DiscoveredDevicesDropdownActions = ({ device }) => {
  const dropdownItems = [
    <AssignDeviceDropdownItem device={device} messageId={"assign_to_group"} />,
    <BlockDeviceDropdownItem device={device} />,
  ];

  const modalItems = [
    <AssignDeviceModalItem device={device} messageId={"assign_to_group"} />,
    <BlockDeviceModalItem device={device} />,
  ];

  return (
    <Fragment>
      <Mobile>
        <DeviceActionsToggle
          deviceName={device.identifiers[0]}
          menuItems={modalItems}
        />
      </Mobile>
      <NotMobile>
        <DeviceDropdownMenu menuItems={dropdownItems} />
      </NotMobile>
    </Fragment>
  );
};
